const carouselItems = [
  {
    id: 1,
    title: '暑期档热播剧单',
    desc: '盘点今夏最值得追的热播剧集，从古装巨制到现代都市，精选口碑佳作陪伴你的夏日时光。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Summer%20drama%20series%20collection%20with%20warm%20golden%20sunset%20lighting%2C%20cinematic%20movie%20posters%20arranged%20artistically%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20film%20festival%20aesthetic%2C%20elegant%20composition&width=800&height=500&seq=carousel-focus-1&orientation=landscape',
  },
  {
    id: 2,
    title: '高分悬疑片单',
    desc: '精选豆瓣8分以上的悬疑推理佳作，烧脑剧情层层反转，每一部都让你欲罢不能。',
    tag: '口碑推荐',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20film%20noir%20inspired%20composition%2C%20golden%20and%20amber%20tones%2C%20cinematic%20mood%2C%20suspenseful%20elegant%20aesthetic&width=800&height=500&seq=carousel-focus-2&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫精选合集',
    desc: '近年来国产动漫佳作频出，从玄幻到科幻、从热血到治愈，为你整理了一份必看国漫清单。',
    tag: '特别策划',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20collection%20with%20warm%20vibrant%20colors%2C%20modern%20anime%20illustration%20style%2C%20coral%20and%20golden%20accent%20lighting%2C%20artistic%20composition%2C%20fantasy%20elements&width=800&height=500&seq=carousel-focus-3&orientation=landscape',
  },
  {
    id: 4,
    title: '经典电影重温',
    desc: '那些年我们追过的经典电影，从黄金年代到千禧佳作，每一部都是不可错过的光影记忆。',
    tag: '怀旧经典',
    image: 'https://readdy.ai/api/search-image?query=Classic%20film%20reel%20and%20vintage%20cinema%20elements%20with%20warm%20nostalgic%20lighting%2C%20golden%20age%20Hollywood%20aesthetic%2C%20soft%20sepia%20tones%2C%20elegant%20retro%20composition%2C%20film%20texture&width=800&height=500&seq=carousel-focus-4&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-focus-2-line"></i>
            <span>特别策划</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            精心策划的影视专题，帮你发现更多优质内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden bg-background-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-background-950/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-3">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80 leading-relaxed max-w-md">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}